import React, { useEffect, useRef, useState } from 'react'
import {Tree, Menu, Layout, message,Col, Row, ConfigProvider, Pagination, Button, Input, Popconfirm, Modal, Tabs, Progress, Empty,} from 'antd'
import {EyeOutlined, RightCircleOutlined, FieldNumberOutlined, LockOutlined, DownOutlined, FileTextOutlined, TeamOutlined, RightOutlined, FormOutlined, ReadOutlined, CodeOutlined, ScheduleOutlined,  RocketOutlined, SyncOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, CalendarOutlined,} from '@ant-design/icons'
import projectStyles from './project.module.less'
import projectDetailStyles from './project-detail.module.less'
import zhCN from 'antd/lib/locale/zh_CN'
import UserInfo, { checkUserLogin } from '../common/user-center/user-info'
import taskLearnStyles from '../task/task-learn.module.less'
import { Link } from 'react-router-dom'
import 'easymde/dist/easymde.min.css'
import ReactMarkdown from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import gfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import lodingGif from '../../static/image/task/loding.gif'
import logoIconSvg from '../../static/image/logo-icon.svg'
import Draggable from 'react-draggable'
import ProjectClassroomManager from './project-classroom'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'
import ProfileOutlined from '@ant-design/icons/lib/icons/ProfileOutlined'
// classempty image removed — using Ant Design Empty component instead
import { getChapterLabels } from '../common/utils/util'
import ProjectMySubmit from './project-my-submit/project-my-submit'
import ProjectStuSubmit from './project-student-submit/project-student-submit'
import CommitDetail from '../oam/components/commit-detail/CommitDetail'
import { ProjectTest } from './project-test/ProjectTest'
import MarkDownEditor from '../components/MarkdownEditor/MarkdownEditor'
import CoursePaymentModal from './components/CoursePaymentModal'
import { showAccessGuideModal } from './components/accessGuideModal'
import { getAccessGuideContentByReason } from './components/modalCopy'

import LoginRegisterModal from '../../component/modal/login-register/login-register'

export interface Props {}

export const ProjectMain: React.FC<Props> = (props) => {
  let location = window.location
  let projectId = parseInt(window.location.search.split('=')[1]) // 项目的ID
  if (!projectId) {
    projectId = 1
  }


  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，
  const [project, setProject] = useState(null as any)
  const currentClassRoomId = useRef(null as any) //当前点击的教室ID

  const [selectedTabKey, setSelectedTabKey] = useState<any>(
    location.search.includes('my_commit_record') ? ['my_commit_record'] : ['1']
  ) //选中的项目菜单项


  const [testList, setTestList] = useState(null as any) //技能检测习题列表
  const [siderCollapsed, setSiderCollapsed] = useState(false) // 侧栏折叠状态
  const [coursePaymentVisible, setCoursePaymentVisible] = useState(false)
  const [pendingAccessInfo, setPendingAccessInfo] = useState(null as any)

  const draggleRef = useRef<HTMLDivElement | null>(null)


  const [submitId, setSubmitId] = useState(-1)


  const refresh_table_tds = ()=>{
    setTimeout(function(){
      const table_tds = document.getElementsByTagName("td") //以下代码设置页面表格内容属性
      console.log(table_tds)
      for(let i=0; i < table_tds.length;  i++){
          try{
            console.log(table_tds[i].innerText)
            table_tds[i].setAttribute('title', table_tds[i].innerText);
          }catch(error1){
            console.log(error1)
          }
        }
    }, 2000); //单位是毫秒

  }



  useEffect(() => {

    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          let _collegeId = response.college_info.college_id
          const isInCollege =
            collegeId !== 0 && collegeId !== null && collegeId !== ''
          const isCollegeTeacher =
            response.college_info?.is_college_teacher == 1
          setCollegeId(_collegeId)
          setCollegeInfo(response.college_info)
          queryProject(_collegeId)
          if (isInCollege == true && isCollegeTeacher == false) {
            //是学生
            window.location.href =
              '/project_main_student?project_id=' + projectId
          } else {
            if (!checkUserLogin()) {
              document.getElementById('show-login-modal')!.click()
            } else {
              //message.success("请先前往个人中心认证院校身份！~");
            }
          }
        }
      }
    )
  }, [])

  /**
   * 查询项目
   */
  const queryProject = (college_id) => {
    // console.log(selectedTabKey)
    sendHttpPostRequest(
      'course/api/query_project_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
        college_id: college_id,
        _key: selectedTabKey[0],
      },
      queryProjectCallback
    )
  }

  // tab页缓存
  const cacheTabPage = (key: any) => {
    sendHttpPostRequest(
      'course/api/cache_project_tab_page/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
        _key: key,
      },
      (response: any) => {
        if (response.code == -100) {
          document.getElementById('show-login-modal')!.click()
        }
        // if (response._key) {
        //     setSelectedTabKey(response._key);
        // }
      }
    )
  }


  /**
   * 查询项目回调
   * @param response
   */
  const queryProjectCallback = (response: any) => {
    // console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      // 成功
      const accessInfo = response?.query_info?.access_info || {}
      if (accessInfo?.can_access == false) {
        setProject(response.query_info)
        showAccessGuide(accessInfo)
      } else if (response.query_info.ispay == 0 || response.query_info.isoutdate == 1) {
        setProject(response.query_info)
        showAccessGuide({
          ...(accessInfo || {}),
          pay_reason:
            response.query_info.isoutdate == 1
              ? 'college_or_course_expired'
              : 'college_course_unconfigured',
          show_personal_pay_cta: 1,
          price_cent: accessInfo?.price_cent,
        })
      } else {
        setProject(response.query_info)
        setTestList(
          typeof response.query_info.test_exercise_list == 'object'
            ? response.query_info.test_exercise_list
            : JSON.parse(response.query_info.test_exercise_list)
        )
        if (response.query_info.in_classroom == 1) {
          currentClassRoomId.current = response.query_info.classroom_id
        }
        if (response._key && !location.search.includes('my_commit_record')) {
          setSelectedTabKey(response._key)
        }
      }
    } /*else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=oam_chapter';
        } */ else {
      message.error(response.message)
    }
  }

  const showAccessGuide = (accessInfo: any) => {
    setPendingAccessInfo(accessInfo || {})
    const payReason = accessInfo?.pay_reason
    const content = getAccessGuideContentByReason(
      payReason,
      '当前项目不可访问，你可以联系机构管理员/工作人员开通，或个人付费继续使用。'
    )

    showAccessGuideModal({
      accessInfo,
      content,
      onPersonalPay: () => {
        setCoursePaymentVisible(true)
      },
    })
  }

  const onCoursePaymentSuccess = () => {
    setCoursePaymentVisible(false)
    queryProject(collegeId)
  }

  const handleClick = (e: any) => {
    setSelectedTabKey(e.key)
    cacheTabPage(e.key)
   
    
    refresh_table_tds()

  }



  interface Props3 {
    title: any
    content: any
  }
  const AimModule: React.FC<Props3> = (props) => {
    return (
      <div className={projectStyles.aimDivWrapper}>
        <div className={projectStyles.aimDivHeader}>{props.title}</div>
        <div className={projectStyles.aimDivContent}>{props.content}</div>
      </div>
    )
  }

  interface Props2 {}


  //项目介绍
  const ProjectIntroduction: React.FC<Props2> = (props) => {
    return (
      <div className={projectStyles.aimWrapper}>

        {/* Hero Banner */}
        <div className={projectDetailStyles.introHeroBanner}>
          <div className={projectDetailStyles.introHeroContent}>
            <div className={projectDetailStyles.introHeroTitle}>实训目标</div>
            <div className={projectDetailStyles.introHeroAim}>{project?.aim}</div>
          </div>
          <div className={projectDetailStyles.introHeroMeta}>
            <span className={projectDetailStyles.introHeroMetaItem}>
              <ClockCircleOutlined style={{marginRight:6}} />{project?.teaching_duration} 课时
            </span>
          </div>
        </div>

        {/* 项目介绍 - 全宽大卡片 */}
        <AimModule
          title="项目介绍"
          content={
            <ReactMarkdown
              className={projectDetailStyles.reactmarkdownProjectIntro}
              remarkPlugins={[gfm, remarkMath]}
              rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
            >
              {project?.description}
            </ReactMarkdown>
          }
        />

        {/* 实践工具 & 前置基础 — 双列网格 */}
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <AimModule title="实践工具" content={
              <div style={{ padding:12, display:'flex', flexWrap:'wrap', gap:8 }}>
                {project?.tools?.split(';')?.map((tool, toolInd) => (
                  <span key={toolInd} className={projectStyles.projectTool} title={tool}>{tool}</span>
                ))}
              </div>
            } />
          </Col>
          <Col xs={24} md={12}>
            <AimModule title="前置基础" content={
              <div style={{ padding:12, display:'flex', flexWrap:'wrap', gap:8 }}>
                {project?.preconditions?.split(';')?.map((skill, skillInd) => (
                  <span key={skillInd} className={projectStyles.projectSkill} title={skill}>{skill}</span>
                ))}
              </div>
            } />
          </Col>
        </Row>

      </div>
    )
  }

  //项目任务
  const ProjectTask: React.FC<Props2> = (props) => {
    const [menu, setMenu] = useState(null as any)
    const chapterId2Start = useRef(null as any)
  
    /**
     * 查询大纲
     */
    useEffect(() => {
      queryMenu() //
    }, [])



    /**
     * 开始章节实训回调
     * @param response
     */
    const startChapterCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        window.open(
          '/task_learn?project/' +
            project?.id +
            '/chapter/' +
            chapterId2Start.current +
            '/task/' +
            response.exercise_id +
            '/'
        )
      } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */ else {
        message.error('开始实训遇到问题！~')
      }
    }
    const queryMenu = () => {
      sendHttpPostRequest(
        'course/api/query_course_submission',
        {
          sessionid: Cookies.get('sessionid'),
          course_id: project.id,
        },
        queryMenuCallback
      )
    }

    /**
     * 查询大纲回调
     * @param response
     */
    const queryMenuCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        setMenu(response.menu)
      } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */ else {
        message.error(response.message)
      }
    }

    const goTaskLearn = (chapterId: number, task: any) => {
      if (task?.pay_locked == 1) {
        showAccessGuide(project?.access_info || {})
        return
      }
      window.open(
        '/task_learn?project/' +
          project?.id +
          '/chapter/' +
          chapterId +
          '/task/' +
          task?.id +
          '/'
      )
    }

    return (
      <div
        className={projectStyles.aimWrapper}
        style={{
          minHeight: 700,
        }}
      >
        {menu?.length > 0 ? menu?.map((chapter, chapterIndx) => {
          return (
            <AimModule
              key={chapterIndx}
              title={
                <>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: 10,
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      background: 'linear-gradient(135deg, #4f46e5, #6366f1)',
                      color: '#fff',
                      fontSize: 14,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {getChapterLabels(chapterIndx)}
                  </span>
                  {chapter.name}
                </>
              }
              content={
                <div>
                  {chapter.description && (
                  <ReactMarkdown
                    className={projectStyles.reactmarkdownProjectIntro}
                    remarkPlugins={[gfm, remarkMath]}
                    rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                  >
                    {chapter.description}
                  </ReactMarkdown>
                  )}

                  <div style={{margin:'12px 0'}}>
                  {chapter?.tasks?.map((task, taskInd)=>(
                    <Row key={taskInd} wrap = {false} className={projectStyles.taskDiv} align={'middle'} style={{cursor: task?.pay_locked == 1 ? 'not-allowed' : 'pointer', opacity: task?.pay_locked == 1 ? 0.72 : 1}}
                    onClick={()=>{goTaskLearn(chapter.id, task)}}>
                      <Col flex={'120px'}>
                          <div> 
                            { task?.status == 1 && <span style={{padding:'8px 12px', borderRadius:999, background:'#Ef44441a', color:'#Ef4444',fontWeight:500}}> <CloseCircleOutlined /> 未通过</span>}
                            { task?.status == 0 && <span style={{padding:'8px 12px', borderRadius:999, background:'#f3f4f6', color:'#4b5563',fontWeight:500}} > <ClockCircleOutlined /> 未开始</span>}
                            { task?.status == 2 && <span style={{padding:'8px 12px', borderRadius:999, background:'rgb(16 185 129 / 0.1)', color:'rgb(16 185 129)',fontWeight:500}} ><CheckCircleOutlined /> 已通过</span>}
                          </div>
                      </Col>

                      <Col flex={'auto'}>
                          <div style={{fontSize:16, fontWeight:500, color:'#374151'}}> {String(chapterIndx+1)}{'.'}{String(taskInd+1)} {' '}{task?.pay_locked == 1 ? '[锁定] ' : ''}{task?.name} </div>
                      </Col>

                      <Col flex={'150px'} style={{textAlign:'right'}}>
                          <div style={{textAlign:'right'}}> 
                            <span className={projectStyles.projectLookover} 
                            onClick={(e)=>{e.preventDefault(); e.stopPropagation(); goTaskLearn(chapter.id, task)}}
                          >{task?.pay_locked == 1 ? '去开通' : task?.status == 2?<><EyeOutlined style={{marginRight:5}} />查看任务</>:task?.status == 1?<><SyncOutlined style={{marginRight:5}}  />重新尝试</>:<><RocketOutlined  style={{marginRight:5}}  rotate={45}/>开始任务</>} </span> </div>
                      </Col>

                    </Row>
                  ))
                  }
                   </div>

                </div>
              }
            />
          )
        }) : (
          <div className={projectStyles.emptyStateWrapper}>
            <Empty description="暂无项目任务" />
          </div>
        )}
      </div>
    )
  }

  /** 报告标签页  我的报告*/

  const ProjectReport: React.FC<Props2> = (props) => {
    const [reportNode, setReportNode] = useState(null as any) //当前报告节点
    const [report, setReport] = useState(null as any) //项目报告
    const [reportLoaded, setReportLoaded] = useState(false) //项目报告加载中
    const [userNodeContent, setUserNodeContent] = useState(null as any) //记录当前节点用户输入的内容

    const nodeId = useRef(null as any) //当前节点ID
    const chapterInd = useRef(0) //当前章节索引
    const nodeInd = useRef(0) //当前节点索引

    const [task, setTask] = useState(null as any) //记录当前节点对应的任务，如果有任务


    const [projectMenu, setProjectMenu] = useState([] as any[]) //项目的大纲

    const animationTimer = useRef<any>()

    useEffect(() => {
      window.onload = function(){
        try{
          refresh_table_tds()
        }catch(error){
          console.log(error)
        }
      } 

      queryProjectReport()
      queryProjectMenu()
    }, [])

    /** 从项目大纲中查找章Id */
    const getChapterIdByTaskId = (taskId) => {
      let result = null
      projectMenu?.map((chapter, chapterInd) => {
        chapter?.tasks.map((item) => {
          if (item.id == taskId) {
            result = chapter.id
          }
        })
      })
      return result
    }

    /** 从项目大纲中查找章和节索引 */
    const getChapterTaskIndByTaskId = (taskId) => {
      let result = { chapterInd: -1, taskInd: -1, taskName: '' }
      projectMenu?.map((chapter, chapterInd) => {
        chapter?.tasks.map((item, itemInd) => {
          if (item.id == taskId) {
            result.chapterInd = chapterInd
            result.taskInd = itemInd
            result.taskName = item.name
          }
        })
      })
      return ((result.chapterInd + 1) +'.' + (result.taskInd + 1) +' ' +result.taskName)
    }

    /** 查询项目的大纲 */
    const queryProjectMenu = () => {
      sendHttpPostRequest(
        'course/api/query_chapter_list',
        {
          sessionid: Cookies.get('sessionid'),
          course_id: project.id,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            // 成功

            setProjectMenu(response.menu)
          } else {
            message.error(response.message)
          }
        }
      )
    }

    // 查询报告大纲
    const queryProjectReport = () => {
      sendHttpPostRequest(
        'report/api/user_query_with_simple_report_task_submission/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          report_id: project?.report_id,
          course_id: projectId,
        },
        (response: any) => {
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            setReport(response.query_info)
            if (reportNode == null) {
              if (response.query_info?.json?.length > 0) {
                if (response.query_info?.json[0]?.tasks?.length > 0) {
                  queryReportNode(response.query_info?.json[0]?.tasks[0]?.id)
                }
              }
            }
          }
        }
      )
    }

    // 查询报告节点
    const queryReportNode = (nodeId) => {
      setReportLoaded(false)
      sendHttpPostRequest(
        'report/api/user_query_node/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          node_id: nodeId,
        },
        (response: any) => {
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            setReportLoaded(true)
            setReportNode(response.query_info)
            setUserNodeContent(response.query_info.content)
            if (response.query_info.exercise_id !== '' && response.query_info.exercise_id != 0) {
              queryTaskInfo(response.query_info.exercise_id) //如果当前包含任务，则将当前用户的结果显示。
            }
          }
        }
      )
    }

    // 保存用户撰写的报告内容
    const saveNodeUserContent = (showMessage) => {
      sendHttpPostRequest(
        'report/api/user_write_report_node/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          node_id: reportNode?.id,
          course_id: projectId,
          content: userNodeContent,
        },
        (response: any) => {
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            if(showMessage){
              message.success('报告内容保存成功~')
            }
            queryProjectReport()
          } else {
            if(showMessage){
              message.error('报告内容保存失败！')
            }
          }
        }
      )
    }

    // 查询任务详情
    const queryTaskInfo = (taskId) => {
      let params = {
        exercise_id: taskId,
        sessionid: Cookies.get('sessionid'),
      }

      sendHttpPostRequest(
        'exercise/api/query_task_by_id/',
        params,
        queryTaskCallback
      )
    }

    const queryTaskCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        setTask(response.exercise_info)
        if (response.exercise_info.submission_info) {
          //如果结果则更新运行信息

 
          if (response.exercise_info.submission_info.is_html) {
            eval(response.exercise_info.submission_info.js_script)
          } else {

          }

          if (response.exercise_info.submission_info.submission_image)
  
            if (response.exercise_info.submission_info.is_animation) {
              clearInterval(animationTimer.current)
              let imgs = response.exercise_info.submission_info.submission_image
              let n = 0
              animationTimer.current = setInterval(function () {
                let imgContain: any =
                  document.getElementById('animation_img') &&
                  document.getElementById('animation_img')
                if (imgContain) {
                  imgContain.src = 'data:image/jpg;base64,' + imgs[n]
                  n = n + 1
                  if (n >= imgs.length) {
                    n = 0
                  }
                }
              }, 100)
            }
        } else {

        }
      } else {
        message.error(response.message)
      }
    }

    /** 将报告大纲转成菜单控件的输入格式 */
    const getTreeData = () => {
      const treeData = [] as any[] //
      report?.json?.map((chapter, chapterInd) => {
        const treeChapter = {
          key: 'chapter_' + chapter.id,
          title: getChapterLabels(chapterInd) + ' ' + chapter.name,
          exercise_id: '',
          node_complete: -1,
          selectable: false,
          children: [] as any[],
        }
        chapter.tasks?.map((node, nodeInd) => {
          treeChapter.children.push({
            key: 'node_' + node.id,
            title:
              String(chapterInd + 1) +
              '.' +
              String(nodeInd + 1) +
              ' ' +
              node.name,
            node_complete: node.node_complete,
            chapterId: chapter.id,
            chapterInd: chapterInd,
            nodeInd: nodeInd,
            exercise_id: node.exercise_id,
          })
        })
        treeData.push(treeChapter)
      })
      return treeData
    }


    /** 用户输入节点报告内容变化 */
    const onUserNodeContentMDChange = (value: any) => {
      // save_note()
      setUserNodeContent(value.text)
    }

    const handleReportNodeSelected = (selectedKeys: any, object: any) => {
      saveNodeUserContent(false) // 先保存填写的内容
      //处理通过报告大纲菜单选择了某一个节点事件
      if (selectedKeys[0]?.split('_')?.length > 1) {
        nodeId.current = selectedKeys[0].split('_')[1]
        nodeInd.current = object.node.nodeInd
        chapterInd.current = object.node.chapterInd
        queryReportNode(nodeId.current)
        document.getElementById("nodeReportWrapper").scrollTop = 0 //TODO
        refresh_table_tds()
      }
    }
    /** 上一个报告节点 */
    const preNode = (e: any) => {
      saveNodeUserContent(false)
      if (nodeInd.current == 0) {
        chapterInd.current = chapterInd.current - 1
        nodeInd.current = report?.json[chapterInd.current].tasks?.length - 1
      } else {
        nodeInd.current = nodeInd.current - 1
      }

      queryReportNode(
        report?.json[chapterInd.current].tasks[nodeInd.current]?.id
      )
      document.getElementById("nodeReportWrapper").scrollTop = 0 //TODO
      refresh_table_tds()
    }
    /** 下一个报告节点 */
    const nextNode = (e: any) => {
      saveNodeUserContent(false)
      if (
        nodeInd.current ==
        report?.json[chapterInd.current].tasks?.length - 1
      ) {
        chapterInd.current = chapterInd.current + 1
        nodeInd.current = 0
      } else {
        nodeInd.current = nodeInd.current + 1
      }

      queryReportNode(
        report?.json[chapterInd.current].tasks[nodeInd.current].id
      )

      document.getElementById("nodeReportWrapper").scrollTop = 0 //TODO
      refresh_table_tds()
    }

    return (

      <div style={{
        height: 'calc(100vh - 92px)',
        overflow: 'hidden',
        borderRadius: 12,
        background: '#fff',
        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
      }}>
 
      {report?.json?.length > 0 ? (
      <Row
        wrap={false}
        style={{flex: 1, minHeight: 0, padding: '16px 20px 0', overflowY: 'hidden'}}
      >
        <Col
          flex="auto"
          style={{
            minWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Row
            style={{
              paddingBottom: 10,
              flexShrink: 0,
              borderBottom: '1px solid #f3f4f6',
              marginBottom: 8,
            }}
            justify="space-between"
            align={'middle'}
            wrap={false}
          >
            <Col flex={'auto'}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                }}
              >
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 32, height: 32,
                  borderRadius: 8,
                  background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                  color: '#fff',
                  fontSize: 13,
                  fontWeight: 700,
                  flexShrink: 0,
                }}>
                  {chapterInd.current + 1}.{nodeInd.current + 1}
                </span>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: '#1f2937',
                    whiteSpace:'nowrap',
                    overflow:'hidden',
                    textOverflow:'ellipsis'
                  }}
                >
                  {reportNode?.name}
                </div>
              </div>
            </Col>

            <Col flex={'320px'} style={{textAlign:'right'}}>
              <div style={{display:'flex', justifyContent:'flex-end', gap:8}}>
                <Button
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    color: '#4f46e5', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe',
                  }}
                  disabled={(nodeInd.current == 0 && chapterInd.current == 0) || !reportLoaded}
                  onClick={preNode}
                >
                  上一步
                </Button>
                <Button
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    color: '#4f46e5', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe',
                  }}
                  disabled={
                    (nodeInd.current ==
                      report?.json[chapterInd.current]?.tasks?.length - 1 &&
                      chapterInd.current == report?.json?.length - 1) ||
                    !reportLoaded
                  }
                  onClick={nextNode}
                >
                  下一步
                </Button>
                <Button
                  type="primary"
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    backgroundColor: '#4f46e5',
                  }}
                  onClick={() => {
                    saveNodeUserContent(true)
                  }}
                  disabled={!reportLoaded}
                >
                  保存
                </Button>
              </div>
            </Col>



          </Row>
          <div
            id={'report-loading'}
            hidden={reportLoaded}
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%,-50%)',
              textAlign: 'center',
            }}
          >
            <img height={100} width={100} src={lodingGif}></img>
          </div>
              
          <div
            id="nodeReportWrapper" 
            hidden={!reportLoaded}
            className={projectStyles.nodeReportWrapper}
            style={{
              overflowY: 'auto',
              flex: 1,
              minHeight: 0,
              paddingBottom: 80,
            }}
          >
            <div className={projectStyles.nodeDesImage}>
              <ReactMarkdown
                className={taskLearnStyles.reactmarkdown}
                remarkPlugins={[gfm, remarkMath]}
                rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
              >
                {reportNode?.description}
              </ReactMarkdown>


            </div>

            {reportNode?.exercise_id !== '' && reportNode?.exercise_id !== 0 && reportNode?.type == 1 &&
               (

                <div style={{paddingTop:10, paddingBottom:10, borderRadius: 12,  background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', border: '1px solid #e2e8f0', fontSize: 14  }}>
                {task?.submission_info?.submission_id !== 0 && (
                  <div >
                     <div style={{maxHeight:400, overflowY:'scroll'}}>
                        {task?.submission_info?.is_html == true && (
                          <div style={{color:'#333', marginLeft: 20,marginRight: 20, display: 'flex',justifyContent: 'center',overflow: 'auto',backgroundColor: '#fff',}}
                            dangerouslySetInnerHTML={{__html: task.submission_info.submission_output?.replaceAll('\n',''),}}
                          />
                        )}

                        {task?.submission_info?.is_html == false && !task?.submission_info?.is_table && (
                            <div style={{marginLeft: 20,marginRight: 20,marginBottom: 10,paddingTop: 0,borderRadius: 5,}}
                
                            >
                                                                    
                                <ReactMarkdown
                                remarkPlugins={[gfm, remarkMath]}
                                className={projectStyles.reactmarkdown}
                                rehypePlugins={[
                                  rehypeHighlight,
                                  rehypeKatex,
                                  rehypeRaw,
                                ]}
                                >
                                {
                                  task?.submission_info?.submission_output.replaceAll('\n', '\n\n')
                                }
                                </ReactMarkdown>
                                        
                            </div>
                        )}

                        {/* 如果是表格字符串  单独处理 */}
                        {task?.submission_info?.is_html == false && task?.submission_info?.output_table_str && task?.submission_info?.is_table && (
                            <div  style={{marginLeft: 20,marginRight: 20,marginBottom: 10,paddingTop: 0,borderRadius: 5,}}
                              dangerouslySetInnerHTML={{__html:task?.submission_info?.output_table_str,}}
                            ></div>
                        )}
                      </div>

                      <div>
                        {task?.submission_info?.submission_image && !task?.submission_info?.is_animation && task?.submission_info?.submission_image?.map(
                            (iamgeBase64, ind) => {
                              return (
                                <div style={{margin: 10,textAlign: 'center',}}
                                  key={String(ind)}
                                >
                                  <img src={'data:image/jpg;base64,' +iamgeBase64} style={{maxHeight:300,borderRadius: 3,}}></img>
                                </div>
                              )
                            }
                          )}

                        {task?.submission_info?.submission_image && task?.submission_info?.is_animation && 
                          <div style={{margin: 10,textAlign: 'center',}}>
                            <img 
                              style={{ maxWidth:'100%'}}
                              id="animation_img"
                              src={
                                'data:image/jpg;base64,' + task.submission_info.submission_image &&
                                task.submission_info.submission_image[0]
                              }
                              alt=""
                            />
                            </div>
                        
                        }

                      </div>
  
                  </div> )}

                  {
                  task?.submission_info?.submission_id !== 0 && (
                  <div style={{ marginTop:10, color: '#999999', textAlign: 'right' }}>
                      （结果由任务{' '}{getChapterTaskIndByTaskId(reportNode?.exercise_id)} 生成）
                    </div> )}

                  {/** 以下是任务没提交 */}
                  {
                    task?.submission_info?.submission_id == 0 && (
                      <div 
                        style={{paddingTop: 24, paddingBottom:24, marginBottom: 10, textAlign: 'center', cursor: 'pointer', color:'#4f46e5', transition: 'all 0.2s'}}
                        onClick={() => {window.open(`task_learn?project/${projectId}/chapter/${getChapterIdByTaskId(reportNode?.exercise_id)}/task/${reportNode?.exercise_id}/`)
                        }}
                      >
                        <RightCircleOutlined
                          style={{ fontSize: 28, marginBottom: 6 }}
                        />
                        <div style={{fontSize: 14, fontWeight: 500}}>
                          本结果由任务{' '}{getChapterTaskIndByTaskId(reportNode?.exercise_id)}{' '}自动生成
                        </div>
                        <div style={{fontSize: 13, color: '#9ca3af', marginTop: 4}}>您尚未完成该任务，点击前往</div>
                      </div>
                    )}


              </div> //taskRungingOutputDiv -结束
 

              )}


            {reportNode?.need_input_info == 2 && (
              <div style={{
                marginTop: 16,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #fafbff 0%, #f5f3ff 100%)',
                border: '1px solid #e0e7ff',
                padding: '16px 18px',
              }}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12}}>
                  <span style={{
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    width: 24, height: 24, borderRadius: 6,
                    background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                    fontSize: 13, color: '#fff', flexShrink: 0,
                  }}>✍</span>
                  <div id="input-info" className={projectStyles.reportInputTitle} style={{marginBottom: 0, flex: 1}}>
                    {reportNode?.input_info}
                  </div>
                </div>

                <div
                  hidden={!reportLoaded}
                  id="user-input-content"
                  className={projectStyles.userReportContentWrapper}
                >
                  <MarkDownEditor
                    preview={false}
                    placeholder="请输入您的分析内容"
                    onChange={onUserNodeContentMDChange}
                    value={userNodeContent}
                    toolbar={'note'}
                    onBlur={() => {} }
                  />
                </div>

                <div style={{marginTop: 8, fontSize: 12, color: '#9ca3af', textAlign: 'right', letterSpacing: 0.2}}>
                  切换节点时将自动保存内容
                </div>
              </div>
            )}

          </div>
          

        </Col>
        <Col
          flex="300px"
          style={{
            marginLeft: 16,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minHeight: 0,
          }}
        >

        <div style={{
          marginBottom:16,
          display: 'flex',
          gap: 8,
          flexShrink: 0,
        }}>
            <Button
              type="primary"
              style={{
                flex: 1,
                borderRadius: 8,
                backgroundColor: '#4f46e5',
                height: 36,
                fontSize: 14,
              }}
              onClick={() => {
                window.open(`/report_preview_my?project_id=${projectId}`)
              }}
            >
              预览报告
            </Button>

            <Button
                style={{
                  flex: 1,
                  borderRadius: 8,
                  height: 36,
                  fontSize: 14,
                  color: '#4f46e5',
                  backgroundColor: '#eef2ff',
                  border: '1px solid #c7d2fe',
                }}
                onClick={() =>
                  window.open(
                    `/full_report_preview?project_id=${projectId}&classroom_id=${currentClassRoomId.current}`
                  )
                }
              >
                参考报告
              </Button>

           </div>

           <div style={{
             padding: '14px 16px',
             borderRadius: 12,
             background: 'linear-gradient(135deg, #f5f3ff 0%, #eef2ff 100%)',
             border: '1px solid #e0e7ff',
             marginBottom: 16,
             flexShrink: 0,
           }}>
             <Row wrap={false} align={'middle'}>
               <Col flex="auto">
                 <div style={{fontSize: 14, fontWeight: 600, color: '#374151'}}>完成进度</div>
               </Col>
               <Col flex="80px" style={{textAlign:'right', paddingRight:4}}>
                 <span style={{fontSize: 20, fontWeight: 700, color: '#4f46e5'}}>{report?.report_complete_percent || 0}%</span>
               </Col>
             </Row>
             <div style={{marginTop: 8}}>
               <Progress showInfo={false} strokeColor='#4f46e5' trailColor={'#e0e7ff'} percent={report?.report_complete_percent} size="small" />
             </div>
           </div>

           <div style={{fontSize: 13, fontWeight: 600, color: '#6b7280', marginBottom: 8, letterSpacing: 1, textTransform: 'uppercase', flexShrink: 0}}>报告大纲</div>
          
          <Row
            align="middle"
            justify="start"
            className={projectStyles.testWrapper}
            style={{overflowY: 'auto', overflowX: 'hidden', flex: 1, minHeight: 0}}
          >
            <div
              style={{ width: '100%' }}
              className={projectStyles.menuTree}
            >
              {reportNode && report?.json && (
                <Tree
                  autoExpandParent={true}
                  switcherIcon={<DownOutlined />}
                  showIcon={false}
                  selectedKeys={['node_' + reportNode?.id]}
                  blockNode={true}
                  treeData={getTreeData()}
                  style={{  }}
                  defaultExpandAll={true}
                  onSelect={handleReportNodeSelected.bind(this)}
                  titleRender={(nodeData) => (
                    <Row justify="start" align="middle" gutter={[4, 4]} style={{ height: 20 }}>
                      <Col span={24}> 
                        <span style={{display: 'inline-block',overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", maxWidth:290}}>
                          {(nodeData as any).node_complete == 1 &&  <span className= {projectStyles.taskCompleteSpan}  />}
                          {(nodeData as any).node_complete == 0 &&  <span className= {projectStyles.taskUncompleteSpan}  />}
                          {nodeData.title}
                        </span>
                      </Col>
                    </Row>
                  )}
                />
              )}
            </div>
          </Row>

        </Col>
      </Row>
      ) : (
        <div className={projectStyles.emptyStateWrapper}>
          <Empty description="暂无报告内容" />
        </div>
      )}

      </div>
    )
  }

  /** 我的笔记汇总 */
  const ProjectMyNotes: React.FC<Props2> = (props) => {
    const [notemenu, setNoteMenu] = useState(null as any)
    const taskId = useRef(null as any) //当前任务ID
    const chapterId = useRef(null as any) //当前章节ID
    const [notes, setNotes] = useState(null as any) //用户当前选中的

    /**
     * 查询大纲
     */
    useEffect(() => {
      queryMenuNotes() //
    }, [])


    const queryMenuNotes = () => {
      sendHttpPostRequest(
        'course/api/query_my_project_notes',
        {
          sessionid: Cookies.get('sessionid'),
          project_id: project.id,
        },
        queryMenuNotesCallback
      )
    }

    /**
     * 查询大纲回调
     * @param response
     */
    const queryMenuNotesCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功

        setNoteMenu(response.menu)
        
        if (taskId.current == null)
        {
          chapterId.current = response.menu[0].id
          taskId.current = response.menu[0].tasks[0].id
        }
        queryUserTaskNote()
      }else {
        message.error(response.message)
      }
    }

    /** 将大纲转成菜单控件的输入格式 */
    const getNotesTreeData = () => {
      const treeData = [] as any[] //
      notemenu?.map((chapter, chapterInd) => {
        const treeChapter = {
          key: 'chapter_' + chapter.id,
          title: getChapterLabels(chapterInd) + ' ' + chapter.name,
          note_status: -1,
          selectable: false,
          children: [] as any[],
        }
        chapter.tasks?.map((task, taskInd) => {
          treeChapter.children.push({
            key: 'task_' + task.id,
            note_status: task.note_status,
            title:
              String(chapterInd + 1) +
              '.' +
              String(taskInd + 1) +
              ' ' +
              task.name,
            chapterId: chapter.id,
          })
        })
        treeData.push(treeChapter)
      })
      return treeData
    }

    const handleMyNoteSelected = (selectedKeys: any, object: any) => {
      //处理通过大纲菜单选择了某一个笔记事件
      queryMenuNotes() //TODO
      if (selectedKeys[0]?.split('_')?.length > 1) {
        taskId.current = selectedKeys[0].split('_')[1]
        chapterId.current = object.node.chapterId
        queryUserTaskNote()
      }
    }

    // 查询用户任务笔记
    const queryUserTaskNote = () => {
      sendHttpPostRequest(
        'course/api/query_note',
        {
          exercise_id: taskId.current,
          chapter_id: chapterId.current,
          sessionid: Cookies.get('sessionid'),
        },
        queryUserTaskNoteCallback
      )
    }

    const queryUserTaskNoteCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        setNotes(response.content)
      }else {
        message.error(response.message)
      }
    }
    // 保存用户任务笔记
    const save_note = () => {
      sendHttpPostRequest(
        'course/api/save_note',
        {
          exercise_id: taskId.current,
          chapter_id: chapterId.current,
          content: notes,
          sessionid: Cookies.get('sessionid'),
        },
        saveUserTaskNoteCallback
      )
    }

    const saveUserTaskNoteCallback = (response) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        document.getElementById('show-login-modal')!.click()
      } else if (response.is_ok == true) {
        // 成功
        //setNotes(response.content)
        //queryMenuNotes()
      } else {
        message.error(response.message)
      }
    }

    /** 用户笔记变化 */
    const onEditMDChange = (value: any) => {
      setNotes(value.text)
    }

    return (
      <div
        style={{
          padding: '5px 0px 5px 0px',
          borderRadius: 10,
          margin: '15px 20px 15px 20px',
          height: 'calc(100vh - 90px)',
          minHeight:700,
        }}
      >
        <div className={projectStyles.classroomListHeader}>
          <Row align="middle" style={{ margin: 0, height: 50 }}>
            <Col span={12} style={{ fontSize: 16, textAlign: 'left' }}>
              {' '}
              我的笔记
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Button
                hidden={true}
                type="primary"
                style={{ width: 100, borderRadius: 15 }}
                onClick={() => {}}
              >
                {' '}
                导 出{' '}
              </Button>
            </Col>
          </Row>
        </div>
        <div
          style={{ height: 1, opacity: 0.5 }}
        ></div>
        <div className={projectStyles.classroomListContent}>
          <Row wrap={false} gutter={[20, 8]} style={{ margin: 0 }}>
            <Col
              style={{
                width: 300,
                height: 'calc(100vh - 180px)',
                borderRight: '1px solid rgba(24,43,43,0.5)',
              }}
            >
              <div  style={{minHeight:610, height:'calc(100vh - 180px)'}} className={projectStyles.menuTree}>
                {notemenu && (
                  <Tree
                    autoExpandParent={true}
                    switcherIcon={<DownOutlined />}
                    defaultSelectedKeys={['task_'+ notemenu[0].tasks[0].id]}
                    
                    showIcon={false}
                    blockNode={true}
                    treeData={getNotesTreeData()}
                    style={{  }}
                    defaultExpandAll={true}
                    onSelect={handleMyNoteSelected.bind(this)}
                    titleRender={(nodeData) => (
                      <Row justify="start" align="middle" gutter={[4, 4]}>
                        <Col span={24}> 
                          <span style={{display: 'inline-block',overflow:'hidden', textOverflow:'ellipsis', whiteSpace: "nowrap", maxWidth:220}}>
                            {(nodeData as any).note_status == 1 &&  <span className= {taskLearnStyles.taskCompleteSpan}  />}
                            {(nodeData as any).note_status == 2 &&  <span className= {taskLearnStyles.taskUncompleteSpan}  />}
                            {nodeData.title}
                          </span>
                        </Col>
                      </Row>
                    )}
                  />
                )}
              </div>
            </Col>

            <Col flex="auto" style={{ position: 'relative' }}>
              <div className={projectStyles.mdtextareamynotes}>
                <MarkDownEditor
                  preview={false}
                  placeholder="请输入笔记内容"
                  onChange={onEditMDChange}
                  value={notes}
                  toolbar={'note'}
                  onBlur={() => save_note()}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
/** 班级管理 */
  const ProjectClassroomList: React.FC<Props2> = (props) => {
    const [myClassRoomList, setMyClassRoomList] = useState(null as any) //我的教师列表

    const [createClassRoomId, setCreateClassRoomId] = useState(null as any) //创建教室Id
    const [createClassRoomName, setCreateClassRoomName] = useState(null as any) //创建教室名
    const [createClassRoomPassword, setCreateClassRoomPassword] = useState(
      null as any
    ) //创建教师密码
    const [createClassRoomNumber, setCreateClassRoomNumber] = useState(
      null as any
    ) //创建教室号

    const [isDeleteVisible, setIsDeleteVisible] = useState(false)
    const [isCreateModalVisible, setIsCreateModalVisible] = useState(false)
    const [collegeId, setCollegeId] = useState(null as any)

    const page = useRef(1) // 记录当前的页数
    const pageSize = useRef(12) // 记录当前每页展示数量
    const [resultSum, setResultSum] = useState(0)

    const draggleRef = useRef<HTMLDivElement | null>(null)

    const [bounds, setBounds] = useState({
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
    })
    const [disabled, setDisabled] = useState(true)

    const onStart = (event: any, uiData: any) => {
      const { clientWidth, clientHeight } = window?.document?.documentElement
      const targetRect = draggleRef?.current?.getBoundingClientRect()
      if (targetRect) {
        setBounds({
          left: -targetRect?.left + uiData?.x,
          right: clientWidth - (targetRect?.right - uiData?.x),
          top: -targetRect?.top + uiData?.y,
          bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        })
      }
    }

    useEffect(() => {
      sendHttpPostRequest(
        'account/api/query_teacher_authenticate',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
        },
        (response: any) => {
          if (response.is_ok == true) {
            if (response?.college_info?.college_id !== '') {
              //已加入机构
              let _collegeId = response.college_info.college_id
              setCollegeId(_collegeId)

              queryMyClassRoomList(projectId, response.college_info.college_id)
            }
          }
        }
      )
    }, [])





    const queryMyClassRoomList = (projectId, collegeID) => {
      sendHttpPostRequest(
        'classroom/api/teacher_query_classroom_list/',
        {
          sessionid: Cookies.get('sessionid'),
          course_id: projectId,
          college_id: collegeID,
          page: page.current,
          pagesize: pageSize.current,
        },
        (response: any) => {
          // console.log(response)
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            setMyClassRoomList(response.query_list)
            setResultSum(response.total_sum)
          } /*else if (response.code == -501) {
                        权限不足
                        window.location.href = '/oam_login?next=oam_menu';
                    } */ else {
            message.error(response.message)
          }
        }
      )
    }



    const deleteClassRoom = (classroom_id) => {
      sendHttpPostRequest(
        'classroom/api/user_delete_classroom/',
        {
          sessionid: Cookies.get('sessionid'),
          classroom_id: classroom_id,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            queryMyClassRoomList(projectId, collegeId)
          } else {
            message.error(response.message)
          }
        }
      )
    }

    const createClassRoom = () => {
      sendHttpPostRequest(
        'classroom/api/user_create_classroom/',
        {
          sessionid: Cookies.get('sessionid'),
          course_id: project.id,
          college_id: collegeId,
          password: createClassRoomPassword,
          name: createClassRoomName,
          number: createClassRoomNumber,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            setCreateClassRoomId(response.classroom_id)
            queryMyClassRoomList(projectId, collegeId)
          } else {
            message.error(response.message)
          }
        }
      )
    }

    const createClass = () => {
      setCreateClassRoomPassword(null as any)
      setCreateClassRoomName(null as any)
      setCreateClassRoomNumber(null as any)
      setIsCreateModalVisible(true)
    }

    const handleCreateOk = () => {
      if (
        createClassRoomPassword == null ||
        createClassRoomPassword?.trim() == ''
      ) {
        message.error('班级密码不能为空！')
        return ''
      }
      if (createClassRoomName == null || createClassRoomName?.trim() == '') {
        message.error('班级名称不能为空！')
        return ''
      }

      setIsCreateModalVisible(false)
      createClassRoom()
    }

    const handleCreateCancel = () => {
      setIsCreateModalVisible(false)
    }

    //页码和页数发生了变化
    const onPageChange = (
      newPage: number,
      newPageSize?: number | undefined
    ) => {
      page.current = newPage ? newPage : 1
      if (newPageSize) {
        pageSize.current = newPageSize
      }
      queryMyClassRoomList(projectId, collegeId)
    }

    return (
      <div
        className={projectStyles.classroomListWrapper}
      >
        <div className={projectStyles.classroomListHeader}>
          <Row align="middle" style={{ margin: '0 0 16px', height: 50 }}>
            <Col span={12} style={{color:'#4b5563', fontWeight:600,fontSize: 18, textAlign: 'left' }}>
              {' '}
              班级管理
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                style={{ width: 120, height: 40, fontSize: 15, fontWeight: 500, borderRadius: 10, backgroundColor: '#4f46e5' }}
                onClick={createClass}
              >
                + 创建班级
              </Button>
            </Col>
          </Row>
        </div>
        <div
          style={{ height: 1, opacity: 0.5 }}
        ></div>

        <div >
        { myClassRoomList?.length != 0 ? (<>
          <Row
              gutter={[24, 24]}
              justify={'start'}
            >
              {myClassRoomList?.map((myClassRoom) => {
                return (
                  <Col
                    key={myClassRoom?.id}
                    xs={24} sm={12} md={8} lg={6}
                  >
                    <div className={projectStyles.classRoomCardWrapper}>
                      {/* 卡片头部 — 深紫渐变 */}
                      <div className={projectStyles.classRoomCardHeader}>
                        <div className={projectStyles.classRoomCardHeaderDeco} />
                        <div className={projectStyles.classRoomCardHeaderDeco2} />
                        <div style={{position:'relative', zIndex:1}}>
                          <div style={{
                            width:40, height:40, borderRadius:10,
                            background:'rgba(255,255,255,0.18)',
                            border:'1px solid rgba(255,255,255,0.3)',
                            display:'flex', alignItems:'center', justifyContent:'center',
                            marginBottom:10, fontSize:18, color:'#fff',
                          }}>
                            <TeamOutlined />
                          </div>
                          <div style={{fontSize:16, fontWeight:700, color:'#fff', lineHeight:1.35, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
                            {myClassRoom?.name}
                          </div>
                          <div style={{fontSize:12, color:'rgba(255,255,255,0.65)', marginTop:4, display:'flex', alignItems:'center', gap:4}}>
                            <ProfileOutlined style={{fontSize:11}} />
                            {myClassRoom?.number}
                          </div>
                        </div>
                      </div>

                      {/* 卡片主体 */}
                      <div className={projectStyles.classRoomCardContent}>
                        {/* 数据统计 */}
                        <div style={{display:'flex', gap:10, marginBottom:16}}>
                          <div style={{
                            flex:1, background:'linear-gradient(135deg, #f5f3ff, #eef2ff)',
                            borderRadius:10, padding:'10px 12px', textAlign:'center',
                            border:'1px solid #e0e7ff',
                          }}>
                            <div style={{fontSize:24, fontWeight:800, color:'#4f46e5', lineHeight:1}}>{myClassRoom?.user_count ?? 0}</div>
                            <div style={{fontSize:11, color:'#9ca3af', marginTop:4, display:'flex', alignItems:'center', justifyContent:'center', gap:3}}>
                              <TeamOutlined style={{fontSize:10}} /> 成员人数
                            </div>
                          </div>
                          <div style={{
                            flex:1, background:'#f8fafc',
                            borderRadius:10, padding:'10px 12px', textAlign:'center',
                            border:'1px solid #e5e7eb',
                          }}>
                            <div style={{fontSize:13, fontWeight:700, color:'#374151', lineHeight:1.4}}>{myClassRoom?.create_time?.slice(0,10)}</div>
                            <div style={{fontSize:11, color:'#9ca3af', marginTop:4, display:'flex', alignItems:'center', justifyContent:'center', gap:3}}>
                              <CalendarOutlined style={{fontSize:10}} /> 创建日期
                            </div>
                          </div>
                        </div>

                        {/* 操作按钮 */}
                        <div style={{display:'flex', gap:8}}>
                          <div
                            style={{flex:1}}
                            className={projectStyles.classRoomCardPreviewBtn}
                            onClick={() => {
                              currentClassRoomId.current = myClassRoom.id
                              setSelectedTabKey('6')
                            }}
                          >
                            查看详情
                          </div>
                          <Popconfirm
                            placement="top"
                            title={'您确定删除此班级吗？'}
                            onCancel={(e: any) => {}}
                            onConfirm={(e: any) => { deleteClassRoom(myClassRoom?.id) }}
                            okText="确认"
                            cancelText="取消"
                          >
                            <div style={{flex:'0 0 60px'}} className={projectStyles.classRoomCardDelBtn}>删除</div>
                          </Popconfirm>
                        </div>
                      </div>
                    </div>                    

                  </Col>
                )
              })}
            </Row> 
            <ConfigProvider locale={zhCN}>
            
            <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  defaultPageSize={12}
                  current={page.current}
                  hideOnSinglePage={true}
                  onChange={onPageChange}
                  style={{textAlign: 'center',
                    marginTop: 20}}
                />
            
          </ConfigProvider>
            </>) : (
            <div className={projectStyles.emptyStateWrapper}>
              <Empty description="您还未创建班级哟~" />
            </div>
          )

      }

        </div>
        <Modal
          title={null}
          width={480}
          closable={true}
          centered={true}
          open={isCreateModalVisible}
          onCancel={handleCreateCancel}
          className={projectStyles.modalCreateClass}
          destroyOnClose={true}
          footer={null}
          modalRender={(modal) => (
            <div>
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
          {/* 弹窗头部 */}
          <div
            style={{ cursor: 'move', padding: '28px 28px 20px' }}
            onMouseOver={() => { if (disabled) setDisabled(false) }}
            onMouseOut={() => setDisabled(true)}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(79,70,229,0.25)',
              }}>
                <ProfileOutlined style={{ color: '#fff', fontSize: 20 }} />
              </div>
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, color: '#1f2937', lineHeight: 1.3 }}>创建班级</div>
                <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>填写班级信息，创建后可邀请学生加入</div>
              </div>
            </div>
          </div>

          {/* 表单区域 */}
          <div style={{ padding: '0 28px 8px' }} className={projectStyles.modalFormContent}>
            <div className={projectStyles.formFieldGroup}>
              <div className={projectStyles.formFieldLabel}>
                <ProfileOutlined style={{ marginRight: 6, color: '#4f46e5' }} />
                班级名称
                <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>
              </div>
              <Input
                onChange={(e) => setCreateClassRoomName(e.target.value)}
                placeholder="例：2024级人工智能一班"
                maxLength={30}
                showCount
              />
            </div>
            <div className={projectStyles.formFieldGroup}>
              <div className={projectStyles.formFieldLabel}>
                <FieldNumberOutlined style={{ marginRight: 6, color: '#4f46e5' }} />
                班级编号
                <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>
              </div>
              <Input
                onChange={(e) => setCreateClassRoomNumber(e.target.value)}
                placeholder="用于学生查找班级，如：AI2024-01"
              />
            </div>
            <div className={projectStyles.formFieldGroup}>
              <div className={projectStyles.formFieldLabel}>
                <LockOutlined style={{ marginRight: 6, color: '#4f46e5' }} />
                加入密码
                <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>
              </div>
              <Input.Password
                onChange={(e) => setCreateClassRoomPassword(e.target.value)}
                placeholder="学生加入班级时需输入此密码"
                visibilityToggle={true}
              />
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 6, display: 'flex', alignItems: 'center', gap: 4 }}>
                <LockOutlined style={{ fontSize: 11 }} />
                密码仅用于班级准入验证，请妥善保管
              </div>
            </div>
          </div>

          {/* 底部按钮 */}
          <div style={{
            display: 'flex', gap: 10, padding: '16px 28px 28px', justifyContent: 'flex-end',
            borderTop: '1px solid #f3f4f6', marginTop: 8,
          }}>
            <Button
              style={{
                height: 40, borderRadius: 8, padding: '0 20px', fontSize: 14,
                color: '#6b7280', borderColor: '#e5e7eb',
              }}
              onClick={handleCreateCancel}
            >
              取消
            </Button>
            <Button
              type="primary"
              style={{
                height: 40, borderRadius: 8, padding: '0 24px', fontSize: 14, fontWeight: 600,
                background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(79,70,229,0.3)',
              }}
              onClick={handleCreateOk}
            >
              确认创建
            </Button>
          </div>
        </Modal>

        <Modal
          title={
            <div
              style={{ width: '100%', cursor: 'move', color: '#f2f2f2' }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
            >
              提示
            </div>
          }
          width={450}
          closable={false}
          centered={true}
          open={isDeleteVisible}
          bodyStyle={{ height: 100 }}
          className={projectStyles.modal}
          footer={
            <div>
              <Button
                className={projectStyles.stepsBtn}
                style={{ marginRight: 20, color: '#4f46e5' }}
                onClick={() => {
                  setIsDeleteVisible(false)
                }}
              >
                取消
              </Button>
              <Button
                className={projectStyles.stepsBtn}
                style={{ marginRight: 20, color: '#fff' }}
                type="primary"
                onClick={() => {
                  setIsDeleteVisible(false)
                }}
              >
                确认
              </Button>
            </div>
          }
          modalRender={(modal) => (
            <div>
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
          <div style={{ width: 400, textAlign: 'center' }}>
            <div>
              你确认要删除班级
              <span style={{ color: '#a5b4fc' }}>2021数据科学</span>吗？
            </div>
            <div>删除后不可恢复哦！</div>
          </div>
        </Modal>
      </div>
    )
  }

  const getProjectContent = () => {
    if (selectedTabKey == '2') {
      return (
        <ProjectTest
          setSelectedTabKey={setSelectedTabKey}
          selectedTabKey={selectedTabKey}
          projectId={projectId}
          testList={testList}
          setTestList={setTestList}
        />
      )
    } else if (selectedTabKey == '3') {
      return <ProjectIntroduction />
    } else if (selectedTabKey == '4') {
      return <ProjectTask />
    } else if (selectedTabKey == '5') {
      return <ProjectClassroomList />
    } else if (selectedTabKey == '6') {
      return (
        <ProjectClassroomManager
          classroom_id={currentClassRoomId.current}
          college_id={collegeId}
          course_id={projectId}
          course_name={project?.name}
        />
      )
    } else if (selectedTabKey == '7') {
      return <ProjectMyNotes />
    } else if (selectedTabKey == '8') {
      return <ProjectReport />
    } else if (selectedTabKey == 'my_commit_record') {
      //我的提交记录

      const items = [
        { label: '我的记录', key: 'item-1', children: <ProjectMySubmit /> }, // 务必填写 key
        { label: '学生记录', key: 'item-2', children:  <ProjectStuSubmit
                college_id={collegeId}
                setSelectedTabKey={setSelectedTabKey}
                setSubmitId={setSubmitId}
              />},
      ];

      return (
          <Tabs items={items} style={{padding:24, borderRadius:12,background:'#fff', boxShadow:'0 0 transparent, 0 0 transparent, 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1)'}} tabBarStyle={{borderBottomColor:'#4f46e5'}} />)
      
      
    } else if (selectedTabKey == 'student_commit_record') {
      return (
        <ProjectStuSubmit
          college_id={collegeId}
          setSelectedTabKey={setSelectedTabKey}
          setSubmitId={setSubmitId}
        />
      )
    } else if (selectedTabKey == 'student_commit_detail' && submitId) {
      return (
        <CommitDetail
          mode="teacher"
          projectId={projectId}
          submitId={submitId}
          setSelectedTabKey={setSelectedTabKey}
        />
      )
    } else {
      return <ProjectIntroduction />
    }
  }

  return (
    <Layout style={{ backgroundColor: '#f9fafb', height: '100vh', overflow: 'hidden'}}>
      <div className={projectStyles.headerDiv}>
        <Row
          justify="center"
          align="middle"
          wrap={true}
          style={{ backgroundColor: '#fff', height: 48 }}
        >
          <Col flex={'60px'} style={{ marginLeft: 40 }}>
            <Link to={'/projects'}>
              <img
                key={'0'}
                id={'menu-0'}
                title=""
                alt="logo"
                src={logoIconSvg}
                height={28}
              ></img>
            </Link>
          </Col>
          <Col flex="auto">
            <div style={{ color: '#1f2937', fontSize: 18,fontWeight:600 }}>
              {project?.name}
            </div>
          </Col>

          <Col style={{ marginRight: 40 }}>
            <LoginRegisterModal></LoginRegisterModal>
            <UserInfo></UserInfo>
          </Col>
        </Row>
      </div>

      <Layout
        style={{
          flex: 1,
          backgroundColor: '#f9fafb',
          overflow: 'hidden',
        }}
      >
        <Layout.Sider
          width={200}
          collapsible
          collapsed={siderCollapsed}
          onCollapse={setSiderCollapsed}
          theme="light"
          className={projectStyles.projiceMenuWrapper}
          style={{ minHeight: '100%' }}
        >
            <Menu
              theme="light"
              selectedKeys={
                selectedTabKey == '6'
                  ? '5'
                  : selectedTabKey == 'student_commit_detail'
                  ? 'student_commit_record'
                  : selectedTabKey
              }
              mode="inline"
              onClick={handleClick}
            >
 



             
              <Menu.ItemGroup title="学习">
                <Menu.Item key="3" id="menu-item-3" icon={<ReadOutlined />}>
                  项目介绍
                </Menu.Item>
                <Menu.Item key="2" id="menu-item-2" icon={<FormOutlined />}>
                  检测习题
                </Menu.Item>
                <Menu.Item key="4" id="menu-item-4" icon={<CodeOutlined />}>
                  项目任务
                </Menu.Item>
              </Menu.ItemGroup>

              <Menu.ItemGroup title="管理">
                <Menu.Item key="5" id="menu-item-5" icon={<TeamOutlined />}>
                  班级管理
                </Menu.Item>
                <Menu.Item key="8" id="menu-item-8" icon={<FileTextOutlined />}>
                  我的报告
                </Menu.Item>
                <Menu.Item key="my_commit_record" id="menu-item-9" icon={<ScheduleOutlined />}>
                  提交记录
                </Menu.Item>
              </Menu.ItemGroup>

            </Menu>
        </Layout.Sider>

        <Layout.Content
          style={{
            minWidth: 800,
            position: 'relative',
            padding:'20px 28px',
            overflowY:'auto',
            maxHeight: 'calc(100vh - 52px)'
          }}
        >
          {getProjectContent()}
        </Layout.Content>
      </Layout>

      <CoursePaymentModal
        visible={coursePaymentVisible}
        courseId={projectId}
        priceCent={pendingAccessInfo?.price_cent}
        onSuccess={onCoursePaymentSuccess}
        onCancel={() => {
          setCoursePaymentVisible(false)
        }}
      />
    </Layout>
  )
  
}

export default ProjectMain
